import moment from 'moment';

export default function formatDate(date) {
  const dateRetour = date ? moment(date).format('YYYY-MM-DD') : null;
  if (dateRetour === '0001-01-01') {
    return null;
  }
  return dateRetour;
}
